import { Accordion, AccordionDetails, Divider, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import { ElectoralDataExtendedVM } from 'front-office/view-models/authorization-vote';
import { DatePicker } from '@mui/lab';
import { noop } from 'shell/utils/noop';

interface AccordionElectoralDataComponentProps {
  values?: ElectoralDataExtendedVM;
}

const AccordionElectoralDataComponent = ({
  values,
}: AccordionElectoralDataComponentProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-electoral-data-card"
        id="panel-electoral-data-card"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>{'Dati elettorali'}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={1}>
          <Grid item xs={12} md={3}>
            <PmiTextField
              label="Fascicolo"
              aria-label="Fascicolo"
              value={values?.dossier || ''}
              fullWidth
              disabled
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <PmiTextField
              label="Stato Elettore"
              aria-label="Stato Elettore"
              value={values?.electorState || ''}
              fullWidth
              disabled
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <PmiTextField
              label="Anno Iscrizione"
              aria-label="Anno Iscrizione"
              value={values?.inscriptionYear || ''}
              fullWidth
              disabled
            />
          </Grid>

          <Grid item xs={12} md={3}></Grid>

          <Grid item xs={12} md={3}>
            <PmiTextField
              label="Sezione"
              aria-label="Sezione"
              value={values?.section || ''}
              fullWidth
              disabled
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <PmiTextField
              label="Sede di votazione"
              aria-label="Sede di votazione"
              value={values?.sectionAddress || ''}
              fullWidth
              disabled
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <PmiTextField
              label="Progressivo Sezione"
              aria-label="Progressivo Sezione"
              value={values?.sectionProgressive || ''}
              fullWidth
              disabled
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <PmiTextField
              label="N. Lista Generale"
              aria-label="N. Lista Generale"
              value={values?.generalListNumber || ''}
              fullWidth
              disabled
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <PmiTextField
              label="Collegio Camera Uninominale"
              aria-label="Collegio Camera Uninominale"
              value={values?.roomUni || ''}
              fullWidth
              disabled
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <PmiTextField
              label="Collegio Camera Plurinominale"
              aria-label="Collegio Camera Plurinominale"
              value={values?.roomPluri || ''}
              fullWidth
              disabled
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <PmiTextField
              label="Collegio Senato Uninominale"
              aria-label="Collegio Senato Uninominale"
              value={values?.senateUni || ''}
              fullWidth
              disabled
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <PmiTextField
              label="Collegio Senato Plurinominale"
              aria-label="Collegio Senato Plurinominale"
              value={values?.senatePluri || ''}
              fullWidth
              disabled
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <PmiTextField
              label="Collegio Provinciale"
              aria-label="Collegio Provinciale"
              value={values?.province || ''}
              fullWidth
              disabled
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <PmiTextField
              label="Municipio"
              aria-label="Municipio"
              value={values?.zone || ''}
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12}>
            <PmiTitleDivider>Dati Tessera</PmiTitleDivider>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid container item xs={12} spacing={0} rowSpacing={{ xs: 1, md: 0 }} columnSpacing={1}>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Numero tessera"
                label="Numero tessera"
                id="previousCardNumber"
                name="previousCardNumber"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.previousCardNumber || ''}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Rilasciata il"
                label="Rilasciata il"
                id="previousReleaseDate"
                name="previousReleaseDate"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.previousReleaseDate || ''}
                disabled
              />
            </Grid>
          </Grid>
          <Grid container item xs={12} spacing={0} rowSpacing={{ xs: 1, md: 0 }} columnSpacing={1}>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Motivo emissione"
                label="Motivo emissione"
                id="reasonRelease"
                name="reasonRelease"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.previousReleaseReason || ''}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Stato Tessera"
                label="Stato Tessera"
                id="previousCardState"
                name="previousCardState"
                type="text"
                fullWidth
                variant="outlined"
                value={values?.previousCardState || ''}
                disabled
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <PmiTitleDivider>Dati Consultazione</PmiTitleDivider>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <PmiTextField
              aria-label="Consultazione"
              label="Consultazione"
              id="consultazione"
              name="consultazione"
              type="text"
              fullWidth
              variant="outlined"
              value={values?.consultazione || ''}
              disabled
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DatePicker
              label="Data da"
              aria-label="Data da"
              value={values?.dataDa || null}
              disabled
              onChange={noop}
              renderInput={(params) => (
                <PmiTextField {...params} id="dataDa" fullWidth error={false} helperText="" />
              )}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DatePicker
              label="Data a"
              aria-label="Data a"
              value={values?.dataA || null}
              disabled
              onChange={noop}
              renderInput={(params) => (
                <PmiTextField {...params} id="dataA" fullWidth error={false} helperText="" />
              )}
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

AccordionElectoralDataComponent.displayName = 'Electoral data component';

const AccordionElectoralData = memo(AccordionElectoralDataComponent);

export default AccordionElectoralData;
